import React, { Component } from 'react';
import { arrayOf, bool, func, number, shape, string } from 'prop-types';

import coord from 'propTypes/coord';

import ExistingSegmentPath from '../ExistingSegmentPath';
import ExistingSegmentTooltip from '../ExistingSegmentTooltip';

export default class Segment extends Component {
  static propTypes = {
    onEnter: func.isRequired,
    onLeave: func.isRequired,
    isActive: bool.isRequired,
    priority: number,
    segment: shape({
      id: string,
      path: arrayOf(coord),
    }).isRequired,
  };

  defaultProps = {
    priority: 0,
  };

  shouldComponentUpdate(newProps) {
    if (newProps.isActive !== this.props.isActive) {
      return true;
    }
    if (newProps.priority !== this.props.priority) {
      return true;
    }
    if (newProps.segment.id !== this.props.segment.id) {
      return true;
    }
    return false;
  }

  render() {
    // eslint-disable-next-line global-require
    const PriorityFeatureGroup = require('components/Map/MapComponents/PriorityFeatureGroup')
      .default;

    const { segment, priority, onEnter, onLeave, isActive } = this.props;
    const { id, from: { name: fromName }, to: { name: toName }, path, status } = segment;
    const name = { from: fromName, to: toName };

    return (
      <PriorityFeatureGroup
        key={`Segment-${id}-${status}${isActive ? '-active' : ''}`}
        onMouseover={onEnter}
        onMouseout={onLeave}
        priority={priority}
      >
        <ExistingSegmentPath latLngList={path} isActive={isActive} />
        <ExistingSegmentTooltip name={name} />
      </PriorityFeatureGroup>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Map/CreateSegment/ExistingSegment/index.js